import React from "react";
import { motion } from "framer-motion";

function AboutBanner() {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (
    <>
      {/* inner banner wrape START  */}
      <section className="about-us">
        <motion.div className="inner-banner animate-child"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          custom={0.1}
          variants={fadeUpVariant}
        >
          <div className="container">
            <div className="content-wrape">
              <motion.h2
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                custom={0.2}
                variants={fadeUpVariant}
              >
                <span className="light">Where </span>
                <span className="blue-text">Global </span>
                <span className="black">Businesses Connect</span>
              </motion.h2>
              <motion.p
                className="animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.3}
                variants={fadeUpVariant}
              >Fusing Innovation with Trust to Shape the Future of Global Trade Through Strong Partnerships</motion.p>
            </div>
          </div>
        </motion.div>
      </section>
      {/* inner banner wrape END  */}
    </>
  );
}

export default React.memo(AboutBanner);
